import React from 'react';
import { NavigationUtils } from '../util/NavigationUtils';

export default class ErrorPage extends React.Component {

  handleClick = ($event) => {
    $event.preventDefault();
    NavigationUtils.backToPopin();
  };

  render () {
    return (
      <div className="container py-3">
        <div className="content">
          <div className="col">

            <div className="col w-100 h-100 d-flex">
              <div className="m-auto">Something went wrong. Sorry about that.</div>
            </div>

            <div className="col w-100 h-100 d-flex mt-5">
              <div className="m-auto">
                <button onClick={ this.handleClick } className="btn pop-btn">Back to POPin</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }

}

